import _ from 'lodash';

import GameData from './gameData';

export const parseAzeriteEssences = essences => {
  if (essences === null) {
    return null;
  }

  const essenceParts = _.split(essences, '/');
  let firstEssence = true;
  const azeriteEssences = _.filter(_.map(essenceParts, (part, idx) => {
    if (_.includes(part, ':')) {
      const [essenceId, rank] = _.map(_.split(part, ':'), p => parseInt(p, 10));
      if (!essenceId) {
        return null;
      }
      const major = firstEssence;
      if (firstEssence) {
        firstEssence = false;
      }
      const data = _.find(GameData.AzeriteEssences, { id: essenceId });
      return {
        index: idx,
        essenceId,
        rank,
        major,
        data,
      };
    }
    return {
      index: idx,
      spellId: parseInt(part, 10),
    };
  }));

  // sort into a stable order
  //  * major
  //  * minors, subsorted by essence ID
  //  * milestone spells

  const sorted = _.sortBy(
    azeriteEssences,
    [
      o => !o.major,
      'essenceId',
    ],
  );

  return sorted;
};

export const stringifyAzeriteEssences = essencesArray => {
  if (!essencesArray || essencesArray.length === 0) {
    return '';
  }
  return _.join(
    _.map(essencesArray, essence => {
      if (essence.essenceId) {
        return _.join([essence.essenceId, essence.rank], ':');
      }
      return essence.spellId;
    }),
    '/',
  );
};
